import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button, Modal } from '@grandvisionhq/common';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useDynamicModule } from '@grandvisionhq/utils';
import PreferredStoreSummary from './PreferredStoreSummary.js';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storeModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storeModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePreferredStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const PreferredStore = ({ labels , isModalOpen , onStoreSelect , onOpenModal , onCloseModal , storeCode , errorElement  })=>{
    const { getLabel  } = useIntl();
    const [module, loading, error] = usePreferredStoresModule();
    const { isStoreDetailsEmailEnabled , isStoreDetailsPhoneEnabled  } = useFeatureToggles();
    if (loading) {
        return /*#__PURE__*/ React.createElement(Spinner, {
            "aria-label": getLabel('common.loadingText')
        });
    }
    if (error || !module) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            notifyScreenReader: false,
            className: "alert-m-default"
        }, labels.error);
    }
    const { Containers , StoreFinderProvider , Components  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, errorElement, !storeCode && !isModalOpen && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, labels.noStoreSelected), /*#__PURE__*/ React.createElement(Button, {
        "data-t": "edit-preferred-store",
        className: "preferred-store__add-store",
        variant: "outline",
        size: "small",
        color: "primary",
        caption: labels.addStore,
        onClick: onOpenModal
    })), storeCode && !isModalOpen && /*#__PURE__*/ React.createElement(PreferredStoreSummary, {
        preferredStoreCode: storeCode.toString(),
        onEdit: onOpenModal,
        className: "preferred-store__summary"
    }), isModalOpen && /*#__PURE__*/ React.createElement(Modal, {
        className: "preferred-store__modal",
        showIcon: true,
        iconClassName: "preferred-store__modal__close",
        isOpen: isModalOpen,
        onModalClose: onCloseModal
    }, /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        hidePhone: !isStoreDetailsPhoneEnabled,
        hideEmail: !isStoreDetailsEmailEnabled
    }, /*#__PURE__*/ React.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            title: labels.modalTitle,
            // TODO: Add a better label once confirmed by BA.
            description: labels.modalDescription
        }),
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        }),
        showAttributesAsTags: true
    }))));
};

export { PreferredStore as default };
//# sourceMappingURL=PreferredStore.js.map
